import React from "react";

// components

import TicketForm from "../../components/Cards/TicketForm.js";

export default function NewRequest() {
  const searchParams = new URLSearchParams(window.location.search);
  const sublist = searchParams.get('tt');
  
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">
          <TicketForm sublist={sublist} />
        </div>
        
      </div>
    </>
  );
}
